import { render, staticRenderFns } from "./api_changelog.vue?vue&type=template&id=da2f0252&scoped=true&"
import script from "./api_changelog.vue?vue&type=script&lang=js&"
export * from "./api_changelog.vue?vue&type=script&lang=js&"
import style0 from "./api_changelog.vue?vue&type=style&index=0&id=da2f0252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2f0252",
  null
  
)

export default component.exports